import { throttle } from "throttle-debounce";

const navItems = document.querySelectorAll('.js-nav-item')
const menuItemActiveClass = 'c-nav__item--active'
const defaultPanelEl = document.querySelector('.js-menu-panel-default')
const panelEls = document.querySelectorAll('.js-mega-menu-panel')
const panelActiveClass = 'c-nav-mega--active'
const headerEl = document.querySelector('.js-header-wrap')
const fixedHeaderEl = document.querySelector('.js-fixed-header')
const headerOpenClass = 'c-header-wrap--open'
const bodyFixedClass = 'c-nav-body--fixed'

const menuPanelOff = (menuPanel) => {
  menuPanel.classList.remove(panelActiveClass)
}



const toggleMenuState = (menuPanel) => {
  document.body.classList.add(bodyFixedClass)
  headerEl.classList.add(headerOpenClass)
  menuPanel.classList.add(panelActiveClass)
}

const toggleMenuStateOff = () => {
  document.body.classList.remove(bodyFixedClass)

  if (headerEl) {
    headerEl.classList.remove(headerOpenClass)
  }

  if (navItems.length) {
    navItems.forEach((btn) => btn.classList.remove(menuItemActiveClass))
  }

  if (panelEls.length) {
    panelEls.forEach((el) => el.classList.remove(panelActiveClass))
  }
}

const megaMenu = () => {
  var previouslySelected = null

  if (!headerEl) return

  // Add click events for mega menu toggles
  headerEl.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-mega-menu-toggle')) {
    
      const menuID = e.target?.dataset?.menuId

      if (!menuID) return

      const menuPanel = document.querySelector('[data-menu-panel-id="' + menuID + '"]')

      if (navItems.length) {
        navItems.forEach((btn) => btn.classList.remove(menuItemActiveClass))
      }

      e.target.classList.add(menuItemActiveClass)

      if (previouslySelected) {
        menuPanelOff(previouslySelected)

        if (previouslySelected === menuPanel) {
          toggleMenuStateOff()
          previouslySelected = null
          return
        }
      }

      previouslySelected = menuPanel

      if (menuPanel) {
        return toggleMenuState(menuPanel)
      }
    }

    // Close button
    if (e.target.id === 'js-mega-menu__close') {
      previouslySelected = null
      return toggleMenuStateOff()
    }

    // Close outside
    if (e.target.classList.contains('c-header-wrap--open')) {
      previouslySelected = null
      return toggleMenuStateOff()
    }
  })

  // Make the header fixed on scroll and update class for styling
  window.addEventListener(
    'scroll', 
    throttle(200, () => {
      const scrollDistance 	= window.scrollY;
      
      if( scrollDistance > 300 ) {
        fixedHeaderEl.classList.add('c-header-fixed--reveal');
        headerEl.classList.add('c-header--fixed');
      } else {
        fixedHeaderEl.classList.remove('c-header-fixed--reveal');
        headerEl.classList.remove('c-header--fixed');
      }
    }),
    { passive: true }
  );

  // Esc key
  document.addEventListener('keydown', (e) => {
    if (e.keyCode === 27 && headerEl.classList.contains(headerOpenClass)) {
      previouslySelected = null
      toggleMenuStateOff()
    }
  })

  window.addEventListener('resize', () => {
    if (!defaultPanelEl?.classList) return

    setTimeout(function () {
      if (window.outerWidth >= 600 && defaultPanelEl.classList.contains(panelActiveClass)) {
        toggleMenuStateOff()
      }
    }, 300)
  })
}

export { megaMenu }
